import CuestickHamburgerClosed from "../img/cuestick_hamburger_closed.png"
import CuestickHamburgerOpen from "../img/cuestick_hamburger_open.png"

const CuestickHamburger = ({ open }) => {
    const openW = 40
    const openH = openW
    const closedW = 60
    const closedH = openW / 1.2
    return (
        open ?
            <img
                src={CuestickHamburgerOpen}
                width={openW}
                height={openH}
                className="d-inline-block align-top BREIKKI-logo"
                alt=""
            />
            :
            <img
                src={CuestickHamburgerClosed}
                width={closedW}
                height={closedH}
                className="d-inline-block align-top BREIKKI-logo"
                alt=""
            />
    )
}

export default CuestickHamburger